<template>
  <div class="note-box">
    <div class="note-list"  v-for="(item, index) in noticeList" :key="index" @click="getNoticeDetail(item)">
      <h2>{{item.title}}</h2>
      <span><img src="@/assets/time.png">{{item.addTime}}</span>
      <p v-html="item.content"> </p>
    </div>
  </div>
</template>

<script>
import {pageList} from "../../api/noticeinfo/noticeinfo";
export default {
  name: "noticeIndex",
  data() {
    return {        noticeList: []}
  },

  created() {
    // 公告
    pageList({}).then(res =>{
      if (res.code === 10000) {
        this.noticeList = res.result.records
        console.log(res.result)
      }
    })
  },
  methods:{
    getNoticeDetail(item){
      console.log(item)
      this.$router.push({path: `/notice/noticeDetail?id=${item.id}`})
    },

  }

}
</script>

<style scoped>
.note-box{
  padding:0 10px;
}
.note-list{
  background: #FFFFFF;
  border-radius:6px;
  margin: 8px 0;
  height:160px;
}
.note-list h2{
  display: flex;
  align-items: center;
  border-bottom: 1px solid #dedede;
  height: 45px;
  padding: 0 14px;
  font-size:16px;
  font-family: Microsoft YaHei;
  font-weight: bold;
  color: #000000;
  overflow:hidden;
  text-overflow:ellipsis;
  display:-webkit-box;
  -webkit-line-clamp:1;
  -webkit-box-orient:vertical;
  line-height: 45px;
}
.note-list span{
  display: flex;
  align-items: center;
  font-size:12px;
  font-family: Microsoft YaHei;
  font-weight: 400;
  color: #333333;
  padding:14px 10px 14px 14px;
}
.note-list span img{
  display: flex;
  width:12px;
  margin-right: 2px;
}
.note-list p{
  font-size: 14px;
  font-family: Microsoft YaHei;
  font-weight: 400;
  color: #666666;
  line-height:21px;
  padding: 0 14px 14px 14px;
  overflow:hidden;
  text-overflow:ellipsis;
  display:-webkit-box;
  -webkit-line-clamp:3;
  -webkit-box-orient:vertical;
  height: 65px;
}
</style>
